import React from 'react';
import { PageHeader } from '@cochlear-design-system/foundation';
import { DeceasedView } from '../../PatientRecord/components/DeceasedView';
import { getDeceasedConfig } from '../configs/assignLoanerConfig';

const AssignLoanerDeceasedView = ({
  deceasedPatientName,
  labels,
  country,
  lang,
}) => (
  <>
    <PageHeader
      className="ccl__main-clinic-equipment__title"
      title={{ content: deceasedPatientName }}
    />
    <DeceasedView config={getDeceasedConfig(labels, country, lang)} />
  </>
);

export default AssignLoanerDeceasedView;
